'use strict';
import * as $j_app$002edata$002e$002dUser$002dKind from "./app.data.-User-Kind.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_UserKind$Viewer(organizationName) {
  this.LV = null;
  this.LV = organizationName;
}
export { $c_Lapp_data_UserKind$Viewer as $c_Lapp_data_UserKind$Viewer };
$p = $c_Lapp_data_UserKind$Viewer.prototype = new $j_app$002edata$002e$002dUser$002dKind.$h_Lapp_data_UserKind();
$p.constructor = $c_Lapp_data_UserKind$Viewer;
/** @constructor */
function $h_Lapp_data_UserKind$Viewer() {
}
export { $h_Lapp_data_UserKind$Viewer as $h_Lapp_data_UserKind$Viewer };
$h_Lapp_data_UserKind$Viewer.prototype = $p;
$p.p = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_util_hashing_MurmurHash3$().P(this, (-889275714), false);
});
$p.f = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_data_UserKind$Viewer) && (this.LV === x$0.LV)));
});
$p.n = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().V(this);
});
$p.s = (function() {
  return 1;
});
$p.t = (function() {
  return "Viewer";
});
$p.e = (function(n) {
  if ((n === 0)) {
    return this.LV;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.u = (function(n) {
  if ((n === 0)) {
    return "organizationName";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$p.co = (function() {
  return 0;
});
function $isArrayOf_Lapp_data_UserKind$Viewer(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.D === depth)) && obj.$classData.B.n.k1)));
}
export { $isArrayOf_Lapp_data_UserKind$Viewer as $isArrayOf_Lapp_data_UserKind$Viewer };
var $d_Lapp_data_UserKind$Viewer = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_UserKind$Viewer, "app.data.UserKind$Viewer", ({
  k1: 1,
  fS: 1,
  b: 1,
  c: 1,
  a: 1,
  l: 1
}));
export { $d_Lapp_data_UserKind$Viewer as $d_Lapp_data_UserKind$Viewer };
//# sourceMappingURL=app.data.-User-Kind$-Viewer.js.map
